import { initWebComponent } from '@experience/vite-plugin-wc-extract-styles';
import { createHead } from '@unhead/vue/client';
import { createPinia } from 'pinia';
import { defineCustomElement } from 'vue';
import { createWebHistory, createRouter } from 'vue-router';
import { createI18n } from '@experience/i18n';
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';

import App from '@/App.ce.vue';
import { defaultRoutes } from '@/router';
import { MF_NAME } from '@/shared/consts';

export default initWebComponent({
  elementName: MF_NAME,
  stylesUrl: new URL(`${window.location.origin}/mfs/${MF_NAME}/extracted-styles.css`),
  dev: import.meta.env.DEV,

  defineElement: (styles) =>
    defineCustomElement(App, {
      styles,
      configureApp(app) {
        app.use(createPinia());

        const router = createRouter({
          history: createWebHistory('/'),
          routes: defaultRoutes,
        });

        app.use(router);

        const queryClient = new QueryClient({
          defaultOptions: {
            queries: {
              staleTime: 1000 * 60 * 3, // 3 минуты
            },
          },
        });
        app.use(VueQueryPlugin, { queryClient });

        const head = createHead();
        app.use(head);

        const i18n = createI18n({
          legacy: false,
          locale: 'ru',
        });
        app.use(i18n);
      },
    }),
});
